import React from 'react';
import { Button } from '@/shadcn/components/ui/button';
import { Input } from '@/shadcn/components/ui/input';
import { Label } from '@/shadcn/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shadcn/components/ui/select';
import { AutomationNodeV2 } from '../../types';

interface GenericActionFormProps {
  selectedNode: AutomationNodeV2;
  onUpdateNode: (nodeId: string, updates: Partial<AutomationNodeV2>) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const GenericActionForm: React.FC<GenericActionFormProps> = ({
  selectedNode,
  onUpdateNode,
  onSave,
  onCancel,
}) => {
  const handleMetadataUpdate = (key: string, value: unknown) => {
    onUpdateNode(selectedNode.id, {
      metadata: {
        ...selectedNode.metadata,
        [key]: value,
      },
    });
  };

  const handleSave = () => {
    onSave();
  };

  const currentMetadata = {
    resourceId: selectedNode.metadata.resourceId || 1,
    fromPreviousSender: selectedNode.metadata.fromPreviousSender ?? false,
    ...selectedNode.metadata
  };

  return (
    <div className="space-y-4">
      {/* Required fields for all actions */}
      <div className="space-y-2">
        <Label htmlFor="resourceId">Resource ID</Label>
        <Input
          id="resourceId"
          type="number"
          value={currentMetadata.resourceId || ''}
          onChange={(e) => handleMetadataUpdate('resourceId', parseInt(e.target.value, 10) || 1)}
          placeholder="Enter resource ID"
          min="1"
        />
      </div>

      <div className="space-y-2">
        <Label>From Previous Sender</Label>
        <Select
          value={currentMetadata.fromPreviousSender.toString()}
          onValueChange={(value) => handleMetadataUpdate('fromPreviousSender', value === 'true')}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="false">No</SelectItem>
            <SelectItem value="true">Yes</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* HANDLE_PFA_BOOST specific fields */}
      {selectedNode.subType === 'HANDLE_PFA_BOOST' && (
        <>
          <div className="space-y-2">
            <Label htmlFor="boostId">Boost ID</Label>
            <Input
              id="boostId"
              type="number"
              value={selectedNode.metadata.boostId || ''}
              onChange={(e) => handleMetadataUpdate('boostId', parseInt(e.target.value, 10))}
              placeholder="Enter boost ID"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="brandCatalogId">Brand Catalog ID</Label>
            <Input
              id="brandCatalogId"
              value={selectedNode.metadata.brandCatalogId || ''}
              onChange={(e) => handleMetadataUpdate('brandCatalogId', e.target.value)}
              placeholder="Enter brand catalog ID"
            />
          </div>
        </>
      )}

      {/* Action buttons */}
      <div className="flex justify-end gap-2 pt-4 border-t">
        <Button
          variant="outline"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
        >
          Done
        </Button>
      </div>
    </div>
  );
};
